"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _uiKit = require("@devsta/ui-kit"),
    _AssetPreview = _interopRequireDefault(require("../../../../AssetPreview")),
    _utils = require("../utils");

require("../styles/_asset-list-card.scss");

function AssetsListCard(a) {
  var b = a.item,
      c = a.options,
      d = a.handleClick,
      e = b.title,
      f = b.updatedAt,
      g = b.updatedByUser;
  g = void 0 === g ? {} : g;
  var h = g.firstName,
      i = g.lastName,
      j = (0, _moment["default"])(f, ["x", "YYYY-MM-DDTHH:mm:ss.sssZ"]),
      k = j.format("DD MMM YYYY");
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.List.CardItem, {
    className: "asset-list-card",
    key: b.assetId,
    customCoverImage: _react["default"].createElement(_AssetPreview["default"], (0, _utils.getAssetPreviewProps)({
      asset: b
    })),
    onClick: d
  }, _react["default"].createElement("div", {
    className: "asset-list-card__info"
  }, _react["default"].createElement("div", {
    className: "asset-list-card__info__text"
  }, _react["default"].createElement(_uiKit.Text, {
    heading5: !0,
    className: "asset-list-card__info__text__title",
    ellipsisOverflow: !0
  }, e), _react["default"].createElement(_uiKit.Text, {
    timestamp: !0,
    className: "asset-list-card__info__text__timestamp"
  }, "".concat(h, " ").concat(i, ": ").concat(k))), _react["default"].createElement(_uiKit.ActionPopup, {
    className: "asset-list-card__actions",
    options: c
  }))));
}

var _default = (0, _react.memo)(AssetsListCard);

exports["default"] = _default;